import React, { useEffect, useState } from "react"
import useStyles from "./styles"
import { Box, Button, IconButton, Typography } from "@material-ui/core"
import ArrowBackIosSharp from "@material-ui/icons/ArrowBackIosSharp"
import ArrowForwardIosSharp from "@material-ui/icons/ArrowForwardIosSharp"
import moment from "moment"
import Switch from '@material-ui/core/Switch';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import { useDispatch } from "react-redux"
import CircularProgress from '@material-ui/core/CircularProgress';
import { getCrewForExport } from "../../../actions/crew"
import { pick, isEmpty } from 'lodash'
import * as FileSaver from "file-saver"
import { Parser } from "json2csv"
import { openSnackBar } from "../../../actions/snack-bar"
import { Hidden } from "../../../../node_modules/@material-ui/core/index"



const durationButtons = [
    {
        label: "Week",
        value: "isoWeek",
    },
    {
        label: "Month",
        value: "month",
    },
    {
        label: "Quarter",
        value: "quarter",
    },
    {
        label: "Year",
        value: "year",
    }

]

const CrewDatePicker = () => {
    const classes = useStyles()
    const dispatch = useDispatch()
    const [showLoader, setShowLoader] = useState(false)

    const [dateInfo, setDateInfo] = useState({
        startDate: "",
        endDate: "",
        duration: "",
        value: "",
        wasIncreased: "",
        fullFetch: false,
    })

    // set the date range on first load to current month
    useEffect(() => {
        setDateInfo({
            startDate: moment()
                .startOf("month")
                .format(),
            endDate: moment()
                .endOf("month")
                .format(),
            duration: "month",
            value: 1,
        })
    }, [])


    const [usersType, setUsers] = useState({
        elite: false,
        enhanced: false
    });





    const handleChange = (event) => {
        const { name, checked } = event.target

        if (name === "elite" && checked) setUsers({ elite: true, enhanced: false });

        else if (name === "enhanced" && checked) setUsers({ elite: false, enhanced: true });

        else setUsers({ elite: false, enhanced: false });

    };



    const handleChangeDate = newInfo => {
        /*dont mutate the dateInfo object*/
        let increasedStart = moment(newInfo.startDate)
            .add(newInfo.duration, 1)
            .format()
        let increasedEnd = moment(newInfo.endDate)
            .add(newInfo.duration, 1)
            .format()
        let decreasedStart = moment(newInfo.startDate)
            .subtract(newInfo.duration, 1)
            .format()
        let decreasedEnd = moment(newInfo.endDate)
            .subtract(newInfo.duration, 1)
            .format()

        if (newInfo.duration === "month") {
            if (newInfo.type === "increase") {
                increasedStart = moment(increasedStart).startOf('month').format();
                increasedEnd = moment(increasedEnd).endOf('month').format();
            }

            if (newInfo.type === "decrease") {
                decreasedStart = moment(decreasedStart).startOf('month').format();
                decreasedEnd = moment(decreasedEnd).endOf('month').format();
            }
        }

        /*increase the range and set type to a string*/
        if (newInfo.type === "increase") {
            setDateInfo({
                startDate: increasedStart,
                endDate: increasedEnd,
                duration: newInfo.duration,
                value: newInfo.value,
                type: "",
                fullFetch: false,
            })
        } else if (newInfo.type === "decrease") {
            /*decrease the range and reset type*/
            setDateInfo({
                startDate: decreasedStart,
                endDate: decreasedEnd,
                duration: newInfo.duration,
                value: newInfo.value,
                type: "",
                fullFetch: false,
            })
        } else if (newInfo.type === "changeDuration") {
            /* set start and end to the first and last day of given duration */
            // this is relative to the current date, not a date previously navigated to
            if (newInfo.duration.toLowerCase() === "all") {
                setDateInfo({
                    ...dateInfo,
                    duration: newInfo.duration,
                    fullFetch: true,
                })
            } else {
                setDateInfo({
                    startDate: moment()
                        .startOf(newInfo.duration)
                        .format(),
                    endDate: moment()
                        .endOf(newInfo.duration)
                        .format(),
                    duration: newInfo.duration,
                    value: newInfo.value,
                    type: "",
                    fullFetch: false,
                })
            }
        }
    }


    const csvFieldsLabel = [
        {
            label: 'User Id',
            value: 'id'
        },
        {
            label: 'Name',
            value: 'name'
        },
        {
            label: 'Phone',
            value: 'phone'
        },
        {
            label: 'Email',
            value: 'email'
        },
        {
            label: 'Joining Date',
            value: 'created'
        },
        {
            label: 'Profile Link',
            value: 'link'
        }

    ]


    const csvFieldsLabelForElite = [
        {
            label: 'User Id',
            value: 'id'
        },
        {
            label: 'Name',
            value: 'name'
        },
        {
            label: 'Phone',
            value: 'phone'
        },
        {
            label: 'Email',
            value: 'email'
        },
        {
            label: 'Joining Date',
            value: 'created'
        },
        {
            label: 'Badge',
            value: 'badge'
        },

        {
            label: 'Profile Link',
            value: 'link'
        }
    ]



    let fields = usersType.elite ? csvFieldsLabelForElite : csvFieldsLabel

    function exportFile(data) {
        const opts = { fields }
        try {
            const parser = new Parser(opts)
            const csv = parser.parse(data)
            var file = new Blob([csv], { type: "text/csv" })
            FileSaver.saveAs(file, `CrewData.csv`)
        } catch (err) {
            console.log("Error", err)
            //   dispatch(openSnackBar({ message: "Error downloading expense data" }))
        }

    }

    const handleExportClick = () => {
        setShowLoader(true)
        dispatch(getCrewForExport({ ...pick(dateInfo, ["startDate", "endDate"]), ...usersType })).then((res) => {
            if (!isEmpty(res.users)) {
                let usersData = res.users.map(item => { return ({ ...item, created: moment(item.created).format("MM/DD/YY"), link: window.location.origin + "/" + item.id }) })
                exportFile(usersData)
            }
            else { dispatch(openSnackBar({ message: "No User Found." })) }
            setShowLoader(false)
        }).catch((err) => {
            console.log("Error", err)
            setShowLoader(false)
        })
    }

    return (
        <>
            <Hidden only={["xs", "sm"]}>

                <Box className={classes.root}>
                    {/* Arrow Buttons */}
                    <Box className={classes.leftButtonWrapper}>
                        <IconButton
                            className={classes.backArrow}
                            classes={{ root: classes.iconButton }}
                            color="secondary"
                            size="small"
                            disabled={dateInfo && dateInfo.fullFetch}
                            onClick={() => {
                                handleChangeDate({
                                    startDate: dateInfo.startDate,
                                    endDate: dateInfo.endDate,
                                    duration: dateInfo.duration,
                                    value: dateInfo.value - 1,
                                    type: "decrease",
                                })
                            }}
                        >
                            <ArrowBackIosSharp />
                        </IconButton>
                        <IconButton
                            className={classes.forwardArrow}
                            classes={{ root: classes.iconButton }}
                            color="secondary"
                            size="small"
                            disabled={dateInfo && dateInfo.fullFetch}
                            onClick={() => {
                                handleChangeDate({
                                    startDate: dateInfo.startDate,
                                    endDate: dateInfo.endDate,
                                    duration: dateInfo.duration,
                                    value: dateInfo.value + 1,
                                    type: "increase",
                                })
                            }}
                        >
                            <ArrowForwardIosSharp />
                        </IconButton>
                    </Box>
                    {/* Date Range Title */}
                    <Box className={classes.dateTextWrapper}>
                        <Typography noWrap variant="h6" className={classes.text}>
                            {dateInfo.duration === "all" ? (
                                <span>All Dates Selected</span>
                            ) : (
                                <span>
                                    {moment(dateInfo.startDate).format("MMM DD")} -{" "}
                                    {moment(dateInfo.endDate).format("MMM DD, YYYY")}
                                </span>
                            )}
                        </Typography>

                        <Box className={classes.durationButtonContainer}>
                            {durationButtons.map((x, i) => (
                                <Button
                                    key={i}
                                    color="primary"
                                    classes={
                                        dateInfo.duration === x.value
                                            ? { root: classes.durationButton }
                                            : { root: classes.durationButtonOutlined }
                                    }
                                    size="small"
                                    onClick={() => {
                                        handleChangeDate({
                                            ...dateInfo,
                                            value: 1,
                                            duration: x.value,
                                            type: "changeDuration",
                                        })
                                    }}
                                >
                                    {x.label}
                                </Button>
                            ))}
                        </Box>

                    </Box>
                    {/* Duration Buttons */}

                    <FormControlLabel
                        control={
                            <Switch
                                checked={usersType.elite}
                                onChange={handleChange}
                                name="elite"
                                color="primary"
                            />
                        }
                        label="Elite"
                    />

                    <FormControlLabel
                        control={
                            <Switch
                                checked={usersType.enhanced}
                                onChange={handleChange}
                                name="enhanced"
                                color="primary"
                            />
                        }
                        label="Enhanced"
                    />


                    <Button

                        color="secondary"
                        className={!showLoader ? classes.exportButton : classes.exportButtonDisabled}
                        startIcon={showLoader && <CircularProgress style={{ height: "15px", width: "15px", color: "black" }} />}
                        onClick={handleExportClick}
                        disabled={showLoader ? true : false}
                        variant="outlined"
                    >

                        Export

                    </Button>



                </Box>
            </Hidden>
            <Hidden only={["md", "lg", "xl"]}>
                <Box className={classes.root}>
                    {/* Arrow Buttons */}
                    <Box className={classes.leftButtonWrapper}>
                        <IconButton
                            classes={{ root: classes.iconButton }}
                            color="secondary"
                            size="small"
                            disabled={dateInfo && dateInfo.fullFetch}
                            onClick={() => {
                                handleChangeDate({
                                    startDate: dateInfo.startDate,
                                    endDate: dateInfo.endDate,
                                    duration: dateInfo.duration,
                                    value: dateInfo.value - 1,
                                    type: "decrease",
                                })
                            }}
                        >
                            <ArrowBackIosSharp />
                        </IconButton>
                        <Typography noWrap variant="h6" className={classes.text}>
                            {dateInfo.duration === "all" ? (
                                <span>All Dates Selected</span>
                            ) : (
                                <span>
                                    {moment(dateInfo.startDate).format("MMM DD")} -{" "}
                                    {moment(dateInfo.endDate).format("MMM DD, YYYY")}
                                </span>
                            )}
                        </Typography>
                        <IconButton
                            classes={{ root: classes.iconButton }}
                            color="secondary"
                            size="small"
                            disabled={dateInfo && dateInfo.fullFetch}
                            onClick={() => {
                                handleChangeDate({
                                    startDate: dateInfo.startDate,
                                    endDate: dateInfo.endDate,
                                    duration: dateInfo.duration,
                                    value: dateInfo.value + 1,
                                    type: "increase",
                                })
                            }}
                        >
                            <ArrowForwardIosSharp />
                        </IconButton>
                    </Box>

                    <Box style={{ marginTop: "10px" }}>
                        <Box className={classes.durationButtonContainer}>
                            {durationButtons.map((x, i) => (
                                <Button
                                    key={i}
                                    color="primary"
                                    classes={dateInfo.duration === x.value ? { root: classes.durationButton } : { root: classes.durationButtonOutlined }}
                                    size="small"
                                    onClick={() => { handleChangeDate({ ...dateInfo, value: 1, duration: x.value, type: "changeDuration" }) }}
                                >
                                    {x.label}
                                </Button>
                            ))}
                        </Box>
                    </Box>

                    <Box style={{ marginTop: "10px" }}>
                        <FormControlLabel
                            control={<Switch checked={usersType.elite} onChange={handleChange} name="elite" color="primary" />}
                            label="Elite" />
                        <FormControlLabel
                            control={<Switch checked={usersType.enhanced} onChange={handleChange} name="enhanced" color="primary" />}
                            label="Enhanced" />
                        <Button
                            color="secondary"
                            className={!showLoader ? classes.exportButton : classes.exportButtonDisabled}
                            startIcon={showLoader && <CircularProgress style={{ height: "15px", width: "15px", color: "black" }} />}
                            onClick={handleExportClick}
                            disabled={showLoader ? true : false}
                            variant="outlined"
                        >
                            Export
                        </Button>
                    </Box>
                </Box>
            </Hidden>
        </>

    )
}


export default CrewDatePicker
